export default __webpack_public_path__ + "static/media/result_2.61d92e6b.jpg";